<template>
  <div class="row">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal">
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="code" class="form-control-label" v-required>Vendor Code</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="code"
                    name="code"
                    placeholder
                    class="form-control"
                    v-model="input.code"
                    @keyup="checkVendorCodeExists()"
                    @blur="checkVendorCodeExists()"
                    ref="code"
                  >
                  <small class="text-danger" v-if="vendorCodeExists">Vendor Code already exists</small>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="short_name" class="form-control-label" v-required>Short Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="short_name"
                    name="short_name"
                    placeholder
                    class="form-control"
                    v-model="input.short_name"
                    @keyup="checkShortNameExists()"
                    @blur="checkShortNameExists()"
                    ref="short_name"
                  >
                  <small class="text-danger" v-if="shortNameExists">Short Name already exists</small>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name_tc" class="form-control-label" v-required>Name (中文)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name_tc"
                    name="name_tc"
                    placeholder
                    class="form-control"
                    v-model="input.name_tc"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name_en" class="form-control-label">Name (En)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name_en"
                    name="name_en"
                    placeholder
                    class="form-control"
                    v-model="input.name_en"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="product_range" class="form-control-label" v-required>Product Range</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="product_range"
                    id="product_range"
                    rows="5"
                    placeholder
                    class="form-control"
                    v-model="input.product_range"
                  ></textarea>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_address" class="form-control-label" v-required>Vendor Address</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="vendor_address"
                    name="vendor_address"
                    placeholder
                    class="form-control"
                    v-model="input.vendor_address"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_tel" class="form-control-label" v-required>Vendor Tel</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="vendor_tel"
                    name="vendor_tel"
                    placeholder
                    class="form-control"
                    v-model="input.vendor_tel"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_fax" class="form-control-label">Vendor Fax</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="vendor_fax"
                    name="vendor_fax"
                    placeholder
                    class="form-control"
                    v-model="input.vendor_fax"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_web" class="form-control-label">Vendor Website</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="vendor_web"
                    name="vendor_web"
                    placeholder
                    class="form-control"
                    v-model="input.vendor_web"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="remarks" class="form-control-label">Remarks</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="remarks"
                    id="remarks"
                    rows="5"
                    placeholder
                    class="form-control"
                    v-model="input.remarks"
                  ></textarea>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="enabled" class="form-control-label" v-required>Status</label>
                </div>
                <div class="col-12 col-md-9">
                  <select id="enabled" v-model="input.enabled" class="form-control" :disabled="pageType === 'view'">
                    <option value="">-</option>
                    <option value="0">Disabled</option>
                    <option value="1">Enabled</option>
                  </select>
                </div>
              </div>

              <!-- Primary Contact -->
              <h5 class="mb-3">Primary Contact Person</h5>

              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.name_tc" class="form-control-label" v-required>Name (中文)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.name_tc"
                    name="primary_contact.name_tc"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.name_tc"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.name_en" class="form-control-label">Name (En)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.name_en"
                    name="primary_contact.name_en"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.name_en"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.position" class="form-control-label">Position</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.position"
                    name="primary_contact.position"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.position"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.contact_mobile" class="form-control-label">Contact Mobile</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.contact_mobile"
                    name="primary_contact.contact_mobile"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.contact_mobile"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.contact_tel" class="form-control-label">Contact Tel</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.contact_tel"
                    name="primary_contact.contact_tel"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.contact_tel"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.contact_email" class="form-control-label">Contact Email</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.contact_email"
                    name="primary_contact.contact_email"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.contact_email"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.other_contact" class="form-control-label">Other Contact</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="primary_contact.other_contact"
                    name="primary_contact.other_contact"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.other_contact"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="primary_contact.remarks" class="form-control-label">Remarks</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="primary_contact.remarks"
                    id="primary_contact.remarks"
                    rows="9"
                    placeholder
                    class="form-control"
                    v-model="input.primary_contact.remarks"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import VendorModel from './model/Vendor'
import VendorContactModel from './model/VendorContact'

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Vendor',
        sectionName: 'vendor',
        sectionIcon: 'fas fa-truck',
        type: this.pageType,
        useDefault: true,
        webService: this.$root.WebService.vendor,
        modelID: this.$route.params.id ? this.$route.params.id : null,
        navigation: [
          { name: 'Vendor', route: 'vendor.index' },
          { name: this.$options.filters.capitalize(this.pageType) },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {

        }
      },
      input: VendorModel(),
      requiredInput: [
        {key: 'code', title: 'Vendor Code'},
        {key: 'short_name', title: 'Short Name'},
        {key: 'name_tc', title: 'Name (中文)'},
        {key: 'product_range', title: 'Product Range'},
        {key: 'vendor_address', title: 'Vendor Address'},
        {key: 'vendor_tel', title: 'Vendor Tel'},
        {key: 'enabled', title: 'Status'},
      ],
      modelID: this.$route.params.id ? this.$route.params.id : null,
      vendorCodeExists: false,
      shortNameExists: false,
      processing: false,
      errorObj: {
        status: false,
        message: null
      },
      timer: null
    }
  },
  props: {
    pageType: String
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
    this.checkShortNameExists()
  },
  methods: {
    checkVendorCodeExists(e) {

      if( this.input.code )
        this.$http
          .post(this.WebService.vendor + '/checkVendorCodeExists', {
            code: this.input.code,
            id: this.modelID
          })
          .then((response) => {
            if (response.data > 0) {
              this.vendorCodeExists = true
            } else {
              this.vendorCodeExists = false
            }
          })
          .catch((err) => {

          })
          .finally()

    },
    checkShortNameExists() {
      
      if( this.input.short_name )
        this.$http
          .post(this.WebService.vendor + '/checkShortNameExists', {
            short_name: this.input.short_name,
            id: this.modelID
          })
          .then((response) => {
            if (response.data > 0) {
              this.shortNameExists = true
            } else {
              this.shortNameExists = false
            }
          })
          .catch((err) => {

          })
          .finally()

    },
    extraValidation() {
      let errors = []
      if( this.vendorCodeExists )
        errors.push('Vendor Code already exists')

      if( this.shortNameExists )
        errors.push('Short Name already exists')

      if( !this.input.primary_contact.name_tc )
        errors.push('Primary Contact Name(中文) is required')
      
      return errors
    },
    afterGetData(res) {
      this.input.enabled = this.input.enabled.toString()
      if( res.data.data.primary_contact === null )
        this.input.primary_contact = VendorContactModel()
    },
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation
  }
}
</script>